export const BOOKING_HORIZON_DAY_OPTIONS = [14, 30, 60, 90, 120, 150, 180, 365] as const;

export type BookingHorizonDays = (typeof BOOKING_HORIZON_DAY_OPTIONS)[number];

export const DEFAULT_BOOKING_HORIZON_DAYS: BookingHorizonDays = 14;

// Shared by the therapist settings editor and the onboarding step so both
// offer exactly the values the API accepts.
export const BOOKING_HORIZON_OPTIONS: Array<{
  value: BookingHorizonDays | null;
  short: string;
  label: string;
}> = [
  { value: 14, short: "2 sedm.", label: "2 sedmice unaprijed" },
  { value: 30, short: "1 mj.", label: "1 mjesec" },
  { value: 60, short: "2 mj.", label: "2 mjeseca" },
  { value: 90, short: "3 mj.", label: "3 mjeseca" },
  { value: 120, short: "4 mj.", label: "4 mjeseca" },
  { value: 150, short: "5 mj.", label: "5 mjeseci" },
  { value: 180, short: "6 mj.", label: "6 mjeseci" },
  { value: 365, short: "12 mj.", label: "12 mjeseci" },
  { value: null, short: "Neograničeno", label: "Neograničeno" },
];

// Uses local-time methods so a client's `today` (user-local midnight) produces
// a horizon in the user's calendar, not shifted by the server's UTC offset.
// On a UTC-hosted server the local and UTC views coincide.
export function maxBookableDate(
  horizonDays: BookingHorizonDays | null,
  today: Date = new Date(),
): string | null {
  if (horizonDays == null) return null;
  const d = new Date(today.getTime());
  d.setDate(d.getDate() + horizonDays);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
